export interface processStatement {
    id: number;
    name: string;
}
export const slim_2: Array<processStatement> = [
    {
        id:0,
        name: "Choose...",
    },
    {
        id:3,
        name: "3 Months",
    },
    {
        id:6,
        name: "6 Months",
    },
   
];
